import * as helper from './../../../Assets/Js/helper';

export function VideoHandler() {
	const video:HTMLVideoElement = document.querySelector('video');
	const overlay:HTMLDivElement = document.querySelector('.model-teaser');
	const chatContent = document.querySelector('.model-chat-content');
	const input:HTMLDivElement = document.querySelector('.model-chat-input');
	const chatOverlay = document.querySelector('#chatOverlay');

	function hide() {
		const soundButton = document.querySelector('.model-videostream-preview-volume');
		video.muted = true;
		helper.addClass(video, 'blur')
		helper.addClass(chatContent, 'blur');
		if (soundButton !== null) {
			helper.remove(soundButton);
		}
		if (helper.hasClass(chatOverlay, 'd-none')) {
			helper.removeClass(overlay, 'd-none');
		}
		helper.addClass(input, 'd-none')
	}

	setTimeout(hide,120000);

	helper.addEventListener(video, 'timeupdate', () => {
		if (video.currentTime > video.duration - 3) {
			hide();
		}
	})
}
